import dimbox from 'dimbox';

document.addEventListener('DOMContentLoaded', () => {
    dimbox.setConfig({
        showDownloadButton: false,
        iframeTemplate:
            '<div class="dimbox-iframe-container">' +
            '<iframe src="{{src}}" class="dimbox-iframe" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen class="dimbox-iframe"></iframe>' +
            '<div class="dimbox-caption">{{caption}}</div>' +
            '</div>',
    });
});
